<template>
	<div class="experts">
		<h2>Эксперты</h2>
		<btn l='Добавить эксперта' i='plus' @press="create()" size="medium"/>
		<hr/>
		<i-list :fields="fields" :data="experts" @input="edit"/>
		<modal title="Перевод +" name="expert-edit" :height="340" :noFooter="false">
			<tabs>
        <tab title="Основное">
          <i-form :data="currentExpert" :scheme="formSchemeMain" @input="(data)=>{setExperts(data)}" :showSaveButton="false"/>
        </tab>  
        <tab title="Ru">
          <i-form :data="currentExpert" :scheme="formSchemeRu" @input="(data)=>{setExperts(data)}" :showSaveButton="false"/>
        </tab>  
        <tab title="Kz">
          <i-form :data="currentExpert" :scheme="formSchemeKz" @input="(data)=>{setExperts(data)}" :showSaveButton="false"/>
        </tab>  
        <tab title="En">
          <i-form :data="currentExpert" :scheme="formSchemeEn" @input="(data)=>{setExperts(data)}" :showSaveButton="false"/>
        </tab>   
      </tabs>
      <div slot="footer">
        <btn l="Удалить"  t='d' s='m'  i='trash' @press="remove" pull='left'></btn>
        <btn l="Сохранить" t='s' s='m'  i='save' @press="saveForm" pull='right'></btn>
        <btn l="Отмена" t='df' s='m'  i='times' @press="cancel" pull='right'></btn>
      </div>
		</modal>
	</div>
</template>

<script>
export default {
  name: 'experts',
  methods:{
    cancel(){this.$store.commit('modalClose','expert-edit');},
    saveForm(){_i.bus.$emit('save-form');},
    remove(){
      this.$store.dispatch("expertsRemoveCRUD",this.currentExpert._id);
      this.$store.commit('modalClose', "expert-edit");
    },
  	edit(expert){
  		this.currentExpert = expert;
  		this.$store.commit('modalOpen', "expert-edit");
  	},
  	create(){
  		this.currentExpert = {name:{},jobtitle:{},short:{},text:{ru:"",en:"",kz:""}};
  		this.$store.commit('modalOpen', "expert-edit");
  	},
  	setExperts(expert){
      this.$store.dispatch("expertsSaveCRUD",expert);
      this.$store.commit('modalClose', "expert-edit");
  	}
  },
  created(){
    _i.crudApi.makeStore(this,'experts','content/experts');
    //this.
  },
  computed:{
  	experts(){
  		return this.$store.state.experts.list;
  	}
  },
  data () {
    return {
    	currentExpert:{},
    	formSchemeMain:{
        "image": {
            "type": "image",
            "label": "Фото",
            "required":true
        },
        "group": {
            "type": "number",
            "label": "Приоритет",
            "required":true
        }
      },
      formSchemeRu:{
        "name.ru": {
            "type": "string",
            "label": "Имя",
            "required":true
        },
        "jobtitle.ru": {
            "type": "string",
            "label": "Должность",
            "required":true
        },
        "text.ru": {
            "type": "wysiwyg",
            "label": "Био",
            "required":true
        }
      },
      formSchemeKz:{
        "name.kz": {
            "type": "string",
            "label": "Имя на казахском",
            "required":true
        },
        "jobtitle.kz": {
            "type": "string",
            "label": "Должность на казахском",
            "required":true
        },
        "text.kz": {
            "type": "wysiwyg",
            "label": "Био на казахском",
            "required":true
        }
      },
      formSchemeEn:{
        "name.en": {
            "type": "string",
            "label": "Имя на английском",
            "required":true
        },
        "jobtitle.en": {
            "type": "string",
            "label": "Должность на английском",
            "required":true
        },
        "text.en": {
            "type": "wysiwyg",
            "label": "Био на английском",
            "required":true
        }
    	},
    	fields:[
        {label:'№',type:'index'},
    		{label:'Фото',name:'image', type:'image'},
        {label:'Имя',name:'name.ru'},
        {label:'Должность',name:'jobtitle.ru'},
    	]
    }
  }
}
</script>

<style lang="css" scoped>
.experts{
	padding:6px 12px;
}
</style>